import { render, staticRenderFns } from "./WebsiteItem.vue?vue&type=template&id=36662c6e&scoped=true&"
import script from "./WebsiteItem.vue?vue&type=script&lang=js&"
export * from "./WebsiteItem.vue?vue&type=script&lang=js&"
import style0 from "./WebsiteItem.vue?vue&type=style&index=0&id=36662c6e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36662c6e",
  null
  
)

export default component.exports